"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface Copy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, Copy> = {
  en: {
    eyebrow: "Wedge Wire Screening",
    heading: "Need Custom Wedge Wire Screen Specifications?",
    lead: "Send your required slot opening, profile wire geometry, support rod spacing, and overall dimensions. Our technical team prepares verified engineering proposals and quotations.",
    secondaryLabel: "Contact Our Team"
  },
  zh: {
    eyebrow: "楔形网筛分工程",
    heading: "需要为您的过滤筛分系统定制楔形网规格？",
    lead: "请提供所需的缝隙尺寸、型丝规格、支撑条间距及结构外形尺寸。我们的技术工程团队将为您核算工程方案与正式报价。",
    secondaryLabel: "联系工程团队"
  },
  es: {
    eyebrow: "Cribado de alambre de cuña",
    heading: "¿Necesita especificaciones a medida para rejillas de cuña?",
    lead: "Envíenos el ancho de ranura requerido, el perfil de alambre, la separación de varillas de soporte y las dimensiones generales. Nuestro equipo técnico preparará la propuesta verificada.",
    secondaryLabel: "Contactar al equipo"
  },
  de: {
    eyebrow: "Spaltsiebe & Keildraht",
    heading: "Benötigen Sie maßgeschneiderte Spaltsiebspezifikationen?",
    lead: "Senden Sie uns die erforderliche Spaltweite, Drahtprofile, Tragstababstände und Abmessungen. Unser Fachteam erstellt fundierte technische Angebote.",
    secondaryLabel: "Team kontaktieren"
  },
  fr: {
    eyebrow: "Tamisage à fils métalliques en V",
    heading: "Besoin de spécifications sur mesure pour grilles à fils en coin ?",
    lead: "Transmettez-nous la largeur de fente souhaitée, le profil de fil, l'espacement des barres de support et les cotes d'encombrement. Notre équipe technique établira une offre validée.",
    secondaryLabel: "Contacter l'équipe"
  },
  pt: {
    eyebrow: "Peneiramento com arame perfilado em cunha",
    heading: "Precisa de especificações personalizadas para telas de arame em cunha?",
    lead: "Envie a abertura de ranhura desejada, o perfil do arame, o espaçamento das barras de suporte e as dimensões gerais. Nossa equipe técnica prepara orçamentos e análises verificadas.",
    secondaryLabel: "Fale com a equipe"
  }
};
export default function QuoteCTA() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="quotecta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage"
  }} />;
}